module.exports = __webpack_public_path__ + "img/login2.7e649fe3.png";